import $ from 'jquery';
import UIkit from 'uikit';
import select2 from 'select2';

window.addEventListener('px-ready',function () {
    $(window).on('resize',function(){
        $('.is-service .px-content2col .s3 .expendimageDiv').css('width', '100%');
        var offst = $('.is-service .px-content2col .s3 .expendimageDiv').offset();
        if(offst){
            $('.is-service .px-content2col .s3 .expendimageDiv').css('width', offst.left + $('.is-service .px-content2col .s3 .expendimageDiv').outerWidth());
        }
    }).trigger('resize')
})
